/**
 * Warning badge rendered when one or more metrics flag insufficient
 * sample size. `flags` is the `insufficient_sample_flags` field on
 * `MetricsResult` — each entry is a metric key.
 */
export function InsufficientSampleBadge({ flags }: { flags: string[] }) {
  if (flags.length === 0) return null;
  return (
    <div
      className="border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-700/50 dark:bg-amber-950/40 dark:text-amber-200"
      role="alert"
    >
      <p className="font-semibold">Insufficient sample for some metrics</p>
      <p className="mt-1 text-amber-800 dark:text-amber-300">
        The following metrics need more spins for a reliable estimate:
      </p>
      <ul className="mt-1 list-disc pl-5">
        {flags.map((flag) => (
          <li key={flag} className="font-mono">
            {flag}
          </li>
        ))}
      </ul>
      <p className="mt-2 text-xs text-amber-700 dark:text-amber-400">
        Re-run with at least 100,000 spins for stable headline numbers.
      </p>
    </div>
  );
}
